import React, { useMemo } from 'react';
import { Box, Field, FieldTypes, Text } from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';
import { ICardReplaceDtoReasonEnum } from '@/dtos';
import { CardReplacementReasons } from '@/modules/transaction/Cards/Cards.types';

export enum FIELDS {
  REPLACEMENT_REASON = 'reason',
  CONFIRM_FRAUD = 'isConfirmFraud',
}

export interface FormValues {
  [FIELDS.REPLACEMENT_REASON]?: ICardReplaceDtoReasonEnum;
  [FIELDS.CONFIRM_FRAUD]: boolean;
}

const REPLACEMENT_REASONS = [
  { key: ICardReplaceDtoReasonEnum.LOST, value: CardReplacementReasons.LOST },
  { key: ICardReplaceDtoReasonEnum.STOLEN, value: CardReplacementReasons.STOLEN },
  { key: ICardReplaceDtoReasonEnum.NOT_SENT, value: CardReplacementReasons.NOT_RECEIVED },
  { key: ICardReplaceDtoReasonEnum.DAMAGED, value: CardReplacementReasons.DAMAGED },
  { key: ICardReplaceDtoReasonEnum.DEMOGRAPHIC_CHANGE, value: CardReplacementReasons.DEMOGRAPHIC_CHANGE },
];

interface Props {
  formValues?: FormValues;
}

export default ({ formValues }: Props) => {
  const showConfirmFraudField = useMemo(
    () =>
      formValues?.reason === ICardReplaceDtoReasonEnum.LOST ||
      formValues?.reason === ICardReplaceDtoReasonEnum.STOLEN,
    [formValues?.reason]
  );

  const fields: Field[] = useMemo(() => {
    const source: Field = {
      name: FIELDS.REPLACEMENT_REASON,
      type: FieldTypes.Dropdown,
      singleMode: true,
      label: 'Replacement reason',
      placeholder: 'Select reason',
      validator: yup.string().required(REQUIRED_TEXT),
      options: REPLACEMENT_REASONS,
      showRequireIcon: true,
      defaultValue: '', // generalInfo?.reason,
    };

    const confirmFraud: Field = {
      name: FIELDS.CONFIRM_FRAUD,
      type: FieldTypes.Checkbox,
      label: (
        <Box flex={{ grow: 1 }}>
          <Text margin={{ bottom: 'xsmall' }} weight="bold" color="textBody">
            Confirm fraud on card
          </Text>
          <Box>
            <Text weight="normal" color="textSecondary">
              Participant will no longer be notified or have a view into any future transactions on a card
              with confirmed fraud. All future transactions on this card will continue to be declined.
            </Text>
          </Box>
        </Box>
      ),
      validator: yup.boolean().nullable(),
    };

    return showConfirmFraudField ? [source, confirmFraud] : [source];
  }, [showConfirmFraudField]);

  return fields;
};
